import { Injectable } from '@angular/core';
import { BaseLocationName } from '@core/abstractions';
import { ILocationRequest, LocationOrderField } from '@core/models';
import { LocationService } from '@core/services';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { OrderDirection } from '@shared/enums';
import { LocationLightModel, OffsetPagination } from '@shared/models';
import { MetaDataService } from '@shared/services';
import { RecordHelper } from '@shared/util';
import { first, map, Observable } from 'rxjs';

@UntilDestroy()
@Injectable({
	providedIn: 'root',
})
export class LocationNameService extends BaseLocationName {
	constructor(
		private metaDataService: MetaDataService,
		private _locationService: LocationService,
	) {
		super();
		this.metaDataService
			.getLocations()
			.pipe(untilDestroyed(this))
			.subscribe((locations: LocationLightModel[]) => {
				this._locationsSourceDictionary = RecordHelper.toRecord(locations, 'locationKey');
				this._locationsSource = locations;
			});
	}

	public getLocationNameByKey(locationKey: string): Observable<string | undefined> {
		const request: ILocationRequest = {
			locationKeys: [locationKey],
			orderBy: LocationOrderField.Id,
			orderDirection: OrderDirection.Ascending,
		};

		return this._locationService.getMany(request, OffsetPagination.First()).pipe(map(result => result[0]?.name));
	}
}
